
import {
  STOCK_TAKING_CAR_MANAGEMENT_EXCHANGE_RATES_DATA_MASTER_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_EXCHANGE_RATES_DATA_MASTER_SUCCESS,
  STOCK_TAKING_CAR_MANAGEMENT_EXCHANGE_RATES_DATA_MASTER_FAILURE
  } from '../constants'
  
  export function reducer(state, action) {
    switch (action.type) {
      case STOCK_TAKING_CAR_MANAGEMENT_EXCHANGE_RATES_DATA_MASTER_BEGIN:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getExchangeRatesDataMasterPending: true,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                exchangeRatesOptions: [],
                exchangeRatesOptionsError: null
            }
          }
        }
      case STOCK_TAKING_CAR_MANAGEMENT_EXCHANGE_RATES_DATA_MASTER_SUCCESS:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getExchangeRatesDataMasterPending: false,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                exchangeRatesOptions: action.data,
                exchangeRatesOptionsError: null
            }
          }
        }
      case STOCK_TAKING_CAR_MANAGEMENT_EXCHANGE_RATES_DATA_MASTER_FAILURE:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getExchangeRatesDataMasterPending: false,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                exchangeRatesOptions: [],
                exchangeRatesOptionsError: action.data.error
            }
          }
        }
      default:
        return state
    }
  }
  